export default __webpack_public_path__ + "static/media/steven choi.55b49bbb.jpg";